import { createSlice } from '@reduxjs/toolkit';
import { GetRotableFleet, GetRotableGroup, getRotable, GetRotableFleetGroup } from './rotableThunk';

const initialState = {
    currentPage: 1,
    pageSize: 100,    
    totalRecords: 0,
    selectedFleet: [],
    selectedGroup: [],
    filteredGroup: [],
    searchText: '',
    fleets: [],
    groups: [],
    rotable: [],
    loadingGroup: true,
    loadingFleet: true
}

const rotableSlice = createSlice({
    name: 'rotableSlice',
    initialState,
    reducers: {
        setRotable(state, action) {            
            state.rotable = action.payload;            
        },
        setCurrentPage(state, action){
            state.currentPage = action.payload;
        },
        setPageSize(state, action){
            state.pageSize = action.payload;
        },
        setTotalRecords(state, action) {
            state.totalRecords = action.payload;
        },
        setSelectedFleet(state, action) {
            state.selectedFleet = action.payload;
        },
        setSelectedGroup(state, action) {
            state.selectedGroup = action.payload;
        },
        setSearchText(state, action) {
            state.searchText = action.payload;
        },
        setFilteredGroup(state, action) {
            state.filteredGroup = action.payload;
        },
        setLoadingGroup(state, action) {
            state.loadingGroup = action.payload;
        },
        setLoadingFleet(state, action) {
            state.loadingFleet = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRotable.fulfilled, (state, action) => {
                const response = action.payload.data;
                state.currentPage = response.CurrentPage;
                state.pageSize = response.PageSize;
                state.totalRecords = response.TotalRecords;
                state.rotable = response.Parts;
                state.groups = response.GroupTypes;
            })
            .addCase(getRotable.rejected, (state, action) => {
                state.rotable = [];
            })
            .addCase(GetRotableFleet.fulfilled, (state,action) =>{
                state.fleets = action.payload.data;
                state.loadingFleet = false;
            })
            .addCase(GetRotableFleet.rejected, (state,action) => {
                state.fleets = [];
                state.loadingFleet = false;
            })
            .addCase(GetRotableGroup.fulfilled, (state, action)=>{
                state.groups = action.payload.data;
            })
            .addCase(GetRotableGroup.rejected, (state, action) => {
                state.groups = [];
            })
            .addCase(GetRotableFleetGroup.fulfilled, (state, action) => {
                state.filteredGroup = action.payload.data.GroupTypes;
                state.loadingGroup = false;
            })
            .addCase(GetRotableFleetGroup.rejected, (state, action) => {
                state.filteredGroup = [];
                state.loadingGroup = false;
            })
    }
});

export const { setRotable, setCurrentPage, setTotalRecords, setSelectedFleet, setSelectedGroup, setSearchText, setFilteredGroup, setLoadingGroup, setLoadingFleet } = rotableSlice.actions;
export default rotableSlice.reducer;